/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import type { FiltersState } from '../../FiltersContext';

import { convertLocationFilters } from './locationParams';
import { convertBookingTypeFilters } from './bookingTypeParams';

export function filtersToApiParams(filters: FiltersState): URLSearchParams {
    const params = new URLSearchParams();

    // Location filters
    convertLocationFilters({ params, filters });

    // Booking type filters
    // IMPORTANT: This must come before the individual booking type filters, as they may
    // override the fg parameter set here.
    convertBookingTypeFilters({ params, filters });

    /***************************************************************************
     * Fixed search parameters
     ***************************************************************************/
    params.set('sort', 'score');

    // Number of results to fetch
    params.set('size', '400');

    // Search radius for single location searches
    // This is larger than ui-search because this is more browsing-focused.
    params.set('radius', '140');

    // Always exclude tours and timed entry tours
    params.append('fq', '-entity_type:(tour OR timedentry_tour)');

    return params;
}

// cSpell:ignore timedentry_tour, checkin
